import { postCreateCurrency } from '../api/postCreateCurrency';

export const setPostCreateCurrency = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateCurrency(params);
            window.location.replace('/settings/currency/list')
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}